<div>
  @for (perspective of breakdownPerspectives(); track perspective.focusDimensionLevel.name) {
    <section>
      <h2>{{ focusMeasure()?.fullName }} by {{ perspective.focusDimensionLevel.name }}</h2>
      <p>with variance vs PY
        @if (focusMeasure()?.classOptions?.suffix; as suffix) {
          <span class="suffix">, in {{ suffix }}</span>
        }
      </p>
      <lib-breakdown-chart
        [perspective]="perspective"
        [measure]="focusMeasure()"
        [period]="focusPeriod()"
        [growthMeasure]="growthMeasure()"
      />
    </section>
  }
</div>

